import { render } from "./ConferenceIndex.vue?vue&type=template&id=6f05d456&scoped=true&ts=true"
import script from "./ConferenceIndex.vue?vue&type=script&lang=ts"
export * from "./ConferenceIndex.vue?vue&type=script&lang=ts"

import "./ConferenceIndex.vue?vue&type=style&index=0&id=6f05d456&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f05d456"]])

export default __exports__